import { render, staticRenderFns } from "./index.vue?vue&type=template&id=55e0d4ca&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=55e0d4ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e0d4ca",
  null
  
)

/* custom blocks */
import block0 from "~/lang/products/insurance?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230322165259%2Fpages%2Fcompare-insurance%2Findex.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./index.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsImage: require('/home/ubuntu/nuxt/bonkers/releases/20230322165259/components/widgets/image.vue').default,SiteFeefoMiniSplitTabs: require('/home/ubuntu/nuxt/bonkers/releases/20230322165259/components/site/feefo-mini-split-tabs.vue').default,ProductsPillCta: require('/home/ubuntu/nuxt/bonkers/releases/20230322165259/components/products/pill-cta.vue').default,ProductsHumanising: require('/home/ubuntu/nuxt/bonkers/releases/20230322165259/components/products/humanising.vue').default,ProductsMoreInfo: require('/home/ubuntu/nuxt/bonkers/releases/20230322165259/components/products/more-info.vue').default,SiteFeefo: require('/home/ubuntu/nuxt/bonkers/releases/20230322165259/components/site/feefo.vue').default})
